import React from 'react';
import classNames from 'classnames';
import { DesktopWindows, PhoneAndroid } from '@sparkpost/matchbox-icons';
import { ScreenReaderOnly } from 'src/components/matchbox';
import { ButtonLink } from 'src/components/links';
import useEditorContext from '../hooks/useEditorContext';
import SendTestEmailButton from './SendTestEmailButton';
import styles from './PreviewControlBar.module.scss';

const PreviewControlBar = () => {
  const { previewDevice, setPreviewDevice, canSend } = useEditorContext();
  const hasSendTestEmailButton = canSend;

  return (
    <div className={styles.PreviewControlBar} data-id="preview-contol-bar">
      <div className={styles.PreviewDeviceToggle}>
        <ButtonLink
          className={classNames(
            styles.PreviewDeviceButton,
            previewDevice === 'desktop' && styles.active
          )}
          id="preview-content-desktop-button"
          onClick={() => setPreviewDevice('desktop')}
          data-id="button-desktop-preview"
        >
          <DesktopWindows size={24} />

          <ScreenReaderOnly>Desktop Preview</ScreenReaderOnly>
        </ButtonLink>

        <ButtonLink
          className={classNames(
            styles.PreviewDeviceButton,
            previewDevice === 'mobile' && styles.active
          )}
          id="preview-content-mobile-button"
          onClick={() => setPreviewDevice('mobile')}
          data-id="button-mobile-preview"
        >
          <PhoneAndroid size={24} />

          <ScreenReaderOnly>Mobile Preview</ScreenReaderOnly>
        </ButtonLink>
      </div>

      <div>{hasSendTestEmailButton && <SendTestEmailButton />}</div>
    </div>
  );
};

export default PreviewControlBar;
